<msc-header [company]="company" [access]="access"></msc-header>
<msc-sidebar [me]="me" [company]="company" [access]="access" [sidebar]="sidebar"></msc-sidebar>

<section>
    <router-outlet></router-outlet>
</section>
